import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c935fce"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href", "download"];
import Secrets from "../../onedesk-portal.usersecrets.json";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskWpDirectDownload',
    props: {
        report: {}
    },
    setup(__props) {
        const { report } = __props;
        return (_ctx, _cache) => {
            return (_ctx.report)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.report + _unref(Secrets).AZURE.wpSharedAccessSignature,
                    download: _ctx.report
                }, [
                    _createVNode(OneDeskButton, {
                        icon: "pi pi-download",
                        severity: "primary",
                        label: "Download report"
                    })
                ], 8, _hoisted_1))
                : _createCommentVNode("", true);
        };
    }
});
